/* Native search and collections (Native Search Test theme)
   1) Search drawer start state: Popular Searches pills fill the box and run
      the theme's predictive search; New In rows load on first open.
   2) Results toolbar: sort select drives the theme's AJAX facet form;
      grid / list view toggle (remembered per browser). */
(function () {
  'use strict';

  /* ---------- 1) Search drawer start state ---------- */
  function initDrawer() {
    var drawer = document.getElementById('site-search-sidebar');
    var start = document.getElementById('cx-drawer-start');
    if (!drawer || !start) return;
    var input = drawer.querySelector('[data-js-search-input]');
    var results = drawer.querySelector('[data-js-search-results]');
    if (!input) return;

    function sync() {
      var empty = input.value.trim() === '';
      start.hidden = !empty;
      if (results) results.hidden = empty;
    }
    input.addEventListener('input', sync);
    input.addEventListener('keyup', sync);
    sync();

    start.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-cx-term]');
      if (!pill) return;
      input.value = pill.textContent.trim();
      sync();
      input.focus();
      // The theme's search-form listens for keyup (debounced)
      input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    });

    var loaded = false;
    function loadNewIn() {
      if (loaded) return;
      loaded = true;
      var url = start.getAttribute('data-new-in-url');
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.cx-drawer-item');
          if (!items.length) return;
          var list = start.querySelector('[data-cx-new-in-list]');
          items.forEach(function (el) { list.appendChild(el); });
          start.querySelector('[data-cx-new-in]').hidden = false;
        })
        .catch(function () { loaded = false; });
    }

    // Load when the drawer first becomes visible (or the box gets focus)
    input.addEventListener('focus', loadNewIn);
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (drawer.style.display !== 'none') loadNewIn();
      }).observe(drawer, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  /* ---------- 2) Results toolbar ---------- */
  var VIEW_KEY = 'cxResultsView';

  function applyView(view) {
    document.documentElement.classList.toggle('cx-view-list', view === 'list');
    document.querySelectorAll('[data-cx-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cx-view') === view ? 'true' : 'false');
    });
  }

  function savedView() {
    try { return window.localStorage.getItem(VIEW_KEY) || 'grid'; } catch (e) { return 'grid'; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cx-view]');
    if (!btn) return;
    var view = btn.getAttribute('data-cx-view');
    try { window.localStorage.setItem(VIEW_KEY, view); } catch (err) { /* private mode */ }
    applyView(view);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-cx-sort]');
    if (!select) return;
    var facetForm = document.querySelector('facet-filters-form');
    var hidden = document.querySelector('#FacetFiltersForm input[name="sort_by"][data-cx-sort-hidden]');
    if (facetForm && hidden && typeof facetForm.onSubmitHandler === 'function') {
      hidden.value = select.value;
      var mobileSort = document.querySelector('#FacetFiltersFormMobile select[name="sort_by"]');
      if (mobileSort) mobileSort.value = select.value;
      facetForm.onSubmitHandler({ target: hidden, preventDefault: function () {} });
    } else {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  // Re-apply the view after the facet form swaps the grid in
  if ('MutationObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      var grid = document.getElementById('CollectionProductGrid');
      if (grid) new MutationObserver(function () { applyView(savedView()); }).observe(grid, { childList: true });
    });
  }

  function init() {
    initDrawer();
    applyView(savedView());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* 3) Collection intro "Read more" and 4) search box inside long filter lists */
(function () {
  'use strict';

  function initDesc() {
    document.querySelectorAll('[data-cx-desc]').forEach(function (el) {
      if (el.dataset.cxDescInit) return;
      el.dataset.cxDescInit = '1';
      el.classList.add('is-clamped');
      // Only offer Read more when the text is actually longer than two lines
      if (el.scrollHeight <= el.clientHeight + 4) { el.classList.remove('is-clamped'); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cx-desc-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-clamped') === false;
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  var MIN_VALUES = 8;
  function initFilterSearch() {
    document.querySelectorAll('.facets__disclosure--collapsible').forEach(function (group) {
      var list = group.querySelector('.facets__list');
      if (!list || group.querySelector('.cx-facet-search')) return;
      var items = list.querySelectorAll('li');
      if (items.length <= MIN_VALUES) return;
      var label = (group.querySelector('summary') || {}).textContent || '';
      label = label.replace(/\(\d+\)/, '').trim().toLowerCase();
      var input = document.createElement('input');
      input.type = 'search';
      input.className = 'cx-facet-search';
      input.placeholder = 'Search ' + (label || 'options');
      input.setAttribute('aria-label', input.placeholder);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        list.querySelectorAll('li').forEach(function (li) {
          li.style.display = !q || li.textContent.toLowerCase().indexOf(q) > -1 ? '' : 'none';
        });
        // Let the full filtered list show while searching (the show-more panel caps height)
        var panel = group.querySelector('.show-more_panel');
        if (panel) panel.scrollTop = 0;
        // Matches are all shown while searching, so hide Show more (it would sit on top of them)
        group.classList.toggle('cx-facet-searching', !!q);
      });
      // Stop Enter submitting the filter form
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      var showMore = group.querySelector('show-more') || list;
      showMore.parentNode.insertBefore(input, showMore);
    });
  }

  function init() {
    initDesc();
    initFilterSearch();
    // The theme redraws filter groups after each change; add the search boxes back
    var forms = document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile');
    if ('MutationObserver' in window) {
      var t;
      forms.forEach(function (f) {
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(initFilterSearch, 50); })
          .observe(f, { childList: true, subtree: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 5) Save Your Search: show the button only once the shopper has filtered (or searched) */
(function () {
  'use strict';
  function hasFilters() {
    var p = new URLSearchParams(location.search), found = false;
    p.forEach(function (v, k) {
      // Only real choices count: the form also submits empty price fields and the automatic in-stock filter
      if (k.indexOf('filter.') === 0 && k !== 'filter.v.availability' && v.trim() !== '') found = true;
      if (k === 'q' && v.trim()) found = true;
    });
    return found;
  }
  function update() {
    var show = hasFilters();
    document.querySelectorAll('.cx-save-search').forEach(function (b) { b.hidden = !show; });
  }
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () { var r = orig.apply(this, arguments); setTimeout(update, 0); return r; };
  });
  window.addEventListener('popstate', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
